var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.332 13.588H23.4787C20.3187 13.588 17.7454 11.0146 17.7454 7.85463V4.0013C17.7454 3.26797 17.1454 2.66797 16.412 2.66797H10.7587C6.65203 2.66797 3.33203 5.33464 3.33203 10.0946V21.908C3.33203 26.668 6.65203 29.3346 10.7587 29.3346H21.2387C25.3454 29.3346 28.6654 26.668 28.6654 21.908V14.9213C28.6654 14.188 28.0654 13.588 27.332 13.588Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0676 2.94926C20.5209 2.40259 19.5742 2.77593 19.5742 3.53593V8.18926C19.5742 10.1359 21.2276 11.7493 23.2409 11.7493C24.5076 11.7626 26.2676 11.7626 27.7742 11.7626C28.5342 11.7626 28.9342 10.8693 28.4009 10.3359C26.4809 8.40259 23.0409 4.9226 21.0676 2.94926Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.3359H10C9.45333 18.3359 9 17.8826 9 17.3359C9 16.7893 9.45333 16.3359 10 16.3359H18C18.5467 16.3359 19 16.7893 19 17.3359C19 17.8826 18.5467 18.3359 18 18.3359Z",
    fill: "#979797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 23.668H10C9.45333 23.668 9 23.2146 9 22.668C9 22.1213 9.45333 21.668 10 21.668H15.3333C15.88 21.668 16.3333 22.1213 16.3333 22.668C16.3333 23.2146 15.88 23.668 15.3333 23.668Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.f51a0750d87dbd8517a7c0faefdf37c5.svg";
export { ForwardRef as ReactComponent };